// extracted by mini-css-extract-plugin
export default {"container":"Wi-z","blurb":"Xi-z","links":"Yi-z"};